// extracted by mini-css-extract-plugin
export default {"heading":"header_heading__WamJk","element":"header_element__63V0Z","floating":"header_floating__UTb6J"};